<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col :cols="10">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link class="link-a" to="/Permission/Team"
                            >MANAGE TEAM</router-link
                        >
                        / ADD
                    </h1>
                </v-col>
                <v-col :cols="2" class="text-right"> </v-col>
            </v-row>

            <v-form method="post" id="nativeForm" v-model="valid">
                <v-card class="mt-5 pa-7">
                    <v-row>
                        <v-col cols="11" sm="6" md="4">
                            <v-text-field
                                v-model="form.team_name"
                                label="Team Name"
                                :rules="teamR"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="6" md="4">
                            <v-switch
                                v-model="form.team_status"
                                class="ma-1 pa-3"
                                label="Team Status"
                                :aria-disabled="
                                    form.team_status === 1 ? true : false
                                "
                                value="1"
                            ></v-switch>
                        </v-col>
                        <!-- <v-col cols="11" sm="5" md="3">
                            xx
                        </v-col> -->
                    </v-row>

                    <v-row v-for="(n, index) in form.role" :key="index">
                        <v-col cols="11" sm="6" md="4">
                            <v-text-field
                                v-model="n.role_name"
                                label="Role"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="11" sm="6" md="4">
                            <v-switch
                                v-model="n.role_status"
                                :aria-disabled="
                                    n.role_status === 1 ? true : false
                                "
                                class="ma-1 pa-3"
                                label="Role Status"
                                value="1"
                            ></v-switch>
                        </v-col>

                        <v-col cols="1" class="mt-4" v-if="index === num - 1">
                            <v-btn
                                color="success"
                                fab
                                small
                                class="mt-3"
                                @click="plus()"
                            >
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="11" class="text-right">
                            <v-btn
                                color="success"
                                class="mr-5"
                                @click="save()"
                                :disabled="!valid"
                                rounded
                            >
                                <v-icon class="mr-1">mdi-content-save</v-icon>
                                Save</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/team/`

export default {
    computed: {
        ...mapState(["snackbar"])
    },
    mounted() {
        if (this.$route.params.id) {
            this.get_data()
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            if (this.$route.params.id) {
                let { data } = await axios.get(url + this.$route.params.id)
                this.form = data[0]
                this.form.role.length != ""
                    ? (this.num = this.form.role.length)
                    : 1
                // console.log(this.form.role.length)
                // console.log(this.num)
            }
        },
        async save() {
            if (this.$route.params.id) {
                let { data } = await axios.put(
                    url + this.$route.params.id,
                    this.form
                )
            } else {
                let { data } = await axios.post(url, this.form)
            }
            this.mutatesnackbar()
            this.$root.$router.push({ path: "/Permission/Team" })
        },
        plus() {
            this.num = this.num + 1
            this.form.role.push({
                role_name: "",
                role_status: ""
            })
        }
    },
    data() {
        return {
            form: {
                // team_status: 1,
                role: [
                    {
                        role_name: "",
                        role_status: ""
                    }
                ]
            },
            num: 1,
            valid: false,
            teamR: [v => !!v || "Team Name No is required"]
        }
    }
}
</script>
